module.exports = __webpack_public_path__ + "img/badge-legal-safety.ce52e2f4.svg";